var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { requestTenant } from "@irati/identity/services/tenant";
import inContextEditor from "@irati/utils/lang/service/inContext";
import tracking from "@irati/utils/tracking";
import defaultTenant from "@irati/identity/helpers/defaultTenant";
import { getAllApps } from "../../services/apps";
import loginService from "../../services/login";
import authentication from "../../index";
import defaultAuth from "../../helpers/defaultAuth";
import featureFlagsService from "../../services/featureFlags";
import { ghostLogin as ghostLoginService } from "../../services/ghostUserLogin";
import tokens from "../../services/tokens";
import getSessionId from "../../helpers/getSessionId";
export var LOGIN = { type: "AuthActions_Login" };
export var LOGOUT = { type: "AuthActions_Logout" };
export var AUTH_UPDATE = { type: "AuthActions_AuthUpdate" };
var LoginAction = function (auth) {
    var apps = auth.apps, user = auth.user, userTenant = auth.userTenant, sessionId = auth.sessionId, rememberMe = auth.rememberMe, onboarding = auth.onboarding, featureFlags = auth.featureFlags, upsell = auth.upsell;
    return {
        type: LOGIN,
        auth: {
            user: user,
            apps: apps,
            userTenant: userTenant,
            sessionId: sessionId,
            rememberMe: rememberMe,
            onboarding: onboarding,
            featureFlags: featureFlags,
            upsell: upsell
        }
    };
};
var ResumeAction = function (_a) {
    var apps = _a.apps, userTenant = _a.userTenant, user = _a.user, onboarding = _a.onboarding, featureFlags = _a.featureFlags, upsell = _a.upsell;
    return {
        type: AUTH_UPDATE,
        auth: {
            apps: apps,
            userTenant: userTenant,
            user: user,
            onboarding: onboarding,
            featureFlags: featureFlags,
            upsell: upsell
        }
    };
};
var LogoutAction = function (userTenant) {
    return {
        type: LOGOUT,
        auth: {
            userTenant: userTenant
        }
    };
};
export var UpdateTenantAction = function (userTenant, featureFlags) {
    return {
        type: AUTH_UPDATE,
        auth: {
            userTenant: userTenant,
            featureFlags: featureFlags
        }
    };
};
export var UpdateTokenAction = function (accessToken) {
    return {
        type: AUTH_UPDATE,
        auth: { accessToken: accessToken }
    };
};
export var UpdateAuthAction = function (_a) {
    var user = _a.user, accessToken = _a.accessToken, refreshToken = _a.refreshToken, userTenant = _a.userTenant, rememberMe = _a.rememberMe, onboarding = _a.onboarding, featureFlags = _a.featureFlags;
    return {
        type: AUTH_UPDATE,
        auth: {
            user: user,
            accessToken: accessToken,
            refreshToken: refreshToken,
            userTenant: userTenant,
            rememberMe: rememberMe,
            onboarding: onboarding,
            featureFlags: featureFlags
        }
    };
};
export var resume = function () {
    return function (dispatch, getState) {
        var auth = getState().auth;
        return tokens.resume().then(function (_a) {
            var apps = _a.apps, sessionId = _a.sessionId;
            if (authentication.isInternal() || authentication.isMerchant()) {
                return new Promise(function (resolve) { return resolve(dispatchUpdateTenant(dispatch, defaultAuth.userTenant)); });
            }
            if (authentication.isUserGhost()) {
                return dispatch(ResumeAction(__assign(__assign({}, auth), { apps: apps })));
            }
            return loginService.resume(auth.userTenant, auth.user).then(function (data) {
                return dispatch(ResumeAction(__assign(__assign({ apps: apps }, data), { sessionId: sessionId })));
            });
        });
    };
};
export var login = function (tenant, email, password, rememberMe) {
    return function (dispatch) {
        return loginService.login(tenant, email, password).then(function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, userTenant, user, onboarding, featureFlags, upsell, sessionId;
            return __generator(this, function (_a) {
                accessToken = data.accessToken, userTenant = data.userTenant, user = data.user, onboarding = data.onboarding, featureFlags = data.featureFlags, upsell = data.upsell;
                tokens.set({ accessToken: accessToken });
                sessionId = getSessionId(accessToken);
                dispatch(LoginAction({
                    userTenant: userTenant,
                    apps: getAllApps({ featureFlags: featureFlags, userTenant: userTenant, accessToken: accessToken }),
                    user: user,
                    sessionId: sessionId,
                    rememberMe: rememberMe,
                    onboarding: onboarding,
                    featureFlags: featureFlags,
                    upsell: upsell
                }));
                return [2 /*return*/, { userTenant: userTenant, user: user, onboarding: onboarding, featureFlags: featureFlags }];
            });
        }); });
    };
};
export var singleSignOn = function (tenant, auth) {
    return function (dispatch) {
        var accessToken = auth.access_token;
        tokens.set({ accessToken: accessToken });
        return loginService.ssoLogin(tenant, auth.user, accessToken).then(function (data) {
            var userTenant = data.userTenant, user = data.user, onboarding = data.onboarding, featureFlags = data.featureFlags, upsell = data.upsell;
            var apps = getAllApps({ featureFlags: featureFlags, userTenant: userTenant, accessToken: accessToken });
            var sessionId = getSessionId(accessToken);
            dispatch(LoginAction({
                apps: apps,
                user: user,
                userTenant: userTenant,
                sessionId: sessionId,
                onboarding: onboarding,
                featureFlags: featureFlags,
                rememberMe: true,
                upsell: upsell
            }));
        });
    };
};
export var ghostLogin = function (accessToken, email) {
    return function (dispatch) {
        tokens.set({ accessToken: accessToken });
        return ghostLoginService(email).then(function (data) {
            var user = data.user, userTenant = data.userTenant, featureFlags = data.featureFlags, upsell = data.upsell;
            dispatch(LoginAction({
                apps: getAllApps({ featureFlags: featureFlags, userTenant: userTenant, accessToken: accessToken }),
                user: user,
                userTenant: userTenant,
                featureFlags: featureFlags,
                upsell: upsell
            }));
        });
    };
};
export var logout = function (_a) {
    var _b = (_a === void 0 ? {} : _a).keepTenantData, keepTenantData = _b === void 0 ? true : _b;
    loginService.logout();
    // keep the current userTenant so we keep settings (img, color)
    var userTenant = keepTenantData ? authentication.userTenant() : defaultTenant;
    tracking.trackUserLogout();
    tokens.clear();
    return LogoutAction(userTenant);
};
export var updateTenantFromRegionalIdentity = function (identity, config) {
    if (config === void 0) { config = {}; }
    var tenant = __assign(__assign({}, defaultTenant), { uuid: identity.tenantId, subdomain: identity.subdomain });
    return function (dispatch) {
        return requestTenant(tenant, config).then(function (updatedTenant) { return dispatchUpdateTenant(dispatch, updatedTenant); });
    };
};
export var updateTenant = function (tenant, config) {
    if (tenant === void 0) { tenant = authentication.userTenant(); }
    if (config === void 0) { config = {}; }
    return function (dispatch) {
        return requestTenant(tenant, config).then(function (updatedTenant) { return dispatchUpdateTenant(dispatch, updatedTenant); });
    };
};
var dispatchUpdateTenant = function (dispatch, userTenant) {
    return featureFlagsService.get(userTenant).then(function (featureFlags) {
        inContextEditor.enableForTenant(userTenant);
        dispatch(UpdateTenantAction(userTenant, featureFlags));
        return userTenant;
    });
};
export default {
    login: login,
    resume: resume,
    ghostLogin: ghostLogin,
    singleSignOn: singleSignOn,
    logout: logout,
    updateTenant: updateTenant,
    UpdateTokenAction: UpdateTokenAction,
    UpdateAuthAction: UpdateAuthAction,
    updateTenantFromRegionalIdentity: updateTenantFromRegionalIdentity,
    LoginAction: LoginAction
};
